import { h, Component } from 'preact';
import DefaultTemplate from 'async!./../templates/default/DefaultTemplate';
import Loading from './../loader/Loading';

export default class Home extends Component {

    constructor() {
        super();
        this.state = { siteMetadata: null, isNotFound: false };
    }
    componentDidMount() {
        const { pageId } = this.props;

        if (pageId) {

            fetch(`https://shoutout-mlp.firebaseio.com/pages/${pageId}.json`)
                .then(r => r.json())
                .then(json => {
                    this.setState({ siteMetadata: json, isNotFound: false });
                }).catch(e => {
                    console.error(e);
                    this.setState({ isNotFound: true });
                });

        }
    }

    render() {
        const { siteMetadata } = this.state;
        if (siteMetadata) {
            switch (siteMetadata.templateId) {
                default: {
                    return <DefaultTemplate siteMetadata={siteMetadata} />
                }
            }
        }

        return (<Loading isNotFound={this.state.isNotFound}/>);
    }
}



// WEBPACK FOOTER //
// ./components/home/Home.js